import clsx from 'clsx';

export function Pagination({ pagination, onPageChange }) {
  if (!pagination) return null;
  const { page, totalPages, totalDocs, hasPrevPage, hasNextPage } = pagination;
  if (!totalPages || totalPages <= 1) {
    return (
      <p className="text-xs text-ink-muted">
        {totalDocs ? `${totalDocs} risultati` : 'Nessun risultato'}
      </p>
    );
  }
  return (
    <nav className="flex items-center justify-between gap-3">
      <p className="text-xs text-ink-muted">
        Pagina {page} di {totalPages} - {totalDocs} risultati
      </p>
      <div className="inline-flex gap-1">
        <button
          type="button"
          className={clsx(
            'h-8 rounded-md border border-border px-3 text-xs',
            hasPrevPage ? 'hover:bg-border/40' : 'cursor-not-allowed opacity-40'
          )}
          disabled={!hasPrevPage}
          onClick={() => hasPrevPage && onPageChange(page - 1)}
        >
          Precedente
        </button>
        <button
          type="button"
          className={clsx(
            'h-8 rounded-md border border-border px-3 text-xs',
            hasNextPage ? 'hover:bg-border/40' : 'cursor-not-allowed opacity-40'
          )}
          disabled={!hasNextPage}
          onClick={() => hasNextPage && onPageChange(page + 1)}
        >
          Successiva
        </button>
      </div>
    </nav>
  );
}
